import React from 'react';
import { IconProps } from '../types';
import styles from '../Icons.module.scss';
import { getSvgDimensions } from '../utils';
import { DEFAULT_ICON_SIZE } from '../constants';

const CallIcon: React.FC<IconProps> = ({
    size = DEFAULT_ICON_SIZE,
    width,
    height,
    color = styles.naviIconDefaultColor,
    ...restProps
}) => {
    const { svgHeight, svgWidth } = getSvgDimensions({ height, width, size });
    return (
        <svg
            width={svgWidth}
            height={svgHeight}
            viewBox="0 0 12 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...restProps}
        >
            <path
                d="M11.3 12C9.86667 12 8.46956 11.6804 7.10867 11.0413C5.74733 10.4027 4.54178 9.55822 3.492 8.508C2.44178 7.45822 1.59733 6.25267 0.958667 4.89133C0.319556 3.53044 0 2.13333 0 0.7C0 0.5 0.0666666 0.333333 0.2 0.2C0.333333 0.0666666 0.5 0 0.7 0H3.4C3.55556 0 3.69444 0.0499999 3.81667 0.15C3.93889 0.25 4.01111 0.377778 4.03333 0.533333L4.46667 2.86667C4.48889 3.02222 4.48622 3.16378 4.45867 3.29133C4.43067 3.41933 4.36667 3.53333 4.26667 3.63333L2.66667 5.26667C3.13333 6.06667 3.71667 6.81667 4.41667 7.51667C5.11667 8.21667 5.88889 8.82222 6.73333 9.33333L8.3 7.76667C8.4 7.66667 8.53067 7.59156 8.692 7.54133C8.85289 7.49156 9.01111 7.47778 9.16667 7.5L11.4667 7.96667C11.6222 8 11.75 8.07489 11.85 8.19133C11.95 8.30822 12 8.44444 12 8.6V11.3C12 11.5 11.9333 11.6667 11.8 11.8C11.6667 11.9333 11.5 12 11.3 12Z"
                fill={color}
            />
        </svg>
    );
};

export default CallIcon;
